<div class="w-full flex items-center gap-1 text-sm h-full">
  <button class="flex-1 p-1 rounded border w-16 border-gris-3 font-medium h-full transition-all"
          [class.bg-vert-1]="this.isOnState()"
          [class.text-white]="this.isOnState()"
          [class.fg-gris-1]="!this.isOnState()"
          [class.hover:bg-vert-2]="!this.isOnState()"
          [class.hover:text-white]="!this.isOnState()"
          (click)="this.setToOn()"
  >
    Oui
  </button>
  <button class="flex-1 p-1 rounded border w-16 border-gris-3 font-medium h-full transition-all"
  [class.fg-gris-1]="this.isOnState()"
          [class.bg-gris-3]="!this.isOnState()"
          [class.fg-noir-1]="!this.isOnState()"
          [class.hover:bg-gris-2]="this.isOnState()"
          [class.hover:text-white]="this.isOnState()"

          (click)="this.setToOff()"
  >
    Non
  </button>

</div>
